"use strict";
// Mediator class should connect every feature of Mirror into itself
// It should handle the following deps
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// videorecordings
// WebrtcManager Instance
// CommandManager Instance
// StreamManager instance
// UI Instances
// Imports
const common_manager_1 = require("../webrtc/common-manager");
const ui_1 = require("./ui");
const CommandsManager_1 = __importDefault(require("../general/CommandsManager"));
const messageBroker_1 = __importDefault(require("../general/messageBroker"));
const status_indicator_1 = require("../utils/status-indicator");
const ui_2 = require("common/ui");
class PresenterManager extends common_manager_1.CommonManager {
    constructor(role, name, publicKey, roomKey) {
        console.time("Booting up Presenter Manager");
        super("presenter", role, name, publicKey, roomKey, false);
        console.log("PUBLIC KEY", publicKey, roomKey);
        this.sessionEnded = false;
        this.initialSetup();
        console.log("Booting up Presenter Manager");
    }
    // initializes components and establishes a comunication path between them
    initialSetup() {
        // This is needed for:
        // - to check whether to listen to input changes or not in media devices
        // - It may be used for something else
        window.isHost = this.role === "host";
        common_manager_1.CommonManager.prototype.initialSetup.call(this);
        this.setupUI(CommandsManager_1.default, this);
    }
    sendMessage(message, type, to) {
        messageBroker_1.default.sendMessage(message, type, to);
    }
    NewPeer(peer) {
        common_manager_1.CommonManager.prototype.NewPeer.call(this, peer);
        // Send room status to the connected peer
        this.sendRoomStatus(peer.public_key);
        // update viewport participants
        if (vm.$refs.orchestrator) {
            if (vm.$refs.orchestrator.$refs.viewport) {
                vm.$refs.orchestrator.$refs.viewport.addNewParticipant(peer);
            }
        }
    }
    UpdatePeer(peer) {
        console.log("Peer got updated", peer);
        // UI
        getParticipantList().updatePeer(peer);
        // Send room status
        if (peer.status == "connected") {
            this.sendRoomStatus(peer.public_key);
        }
        // update viewport participants
        if (vm.$refs.orchestrator) {
            if (vm.$refs.orchestrator.$refs.viewport) {
                vm.$refs.orchestrator.$refs.viewport.updateParticipant(peer);
            }
        }
    }
    handlePeerDisconnected(data) {
        common_manager_1.CommonManager.prototype.handlePeerDisconnected.call(this, data);
        for (let i = 0; i < this.peerList.length; i++) {
            if (this.peerList[i].public_key === data.public_key) {
                if (vm.$refs.orchestrator) {
                    if (vm.$refs.orchestrator.$refs.viewport) {
                        vm.$refs.orchestrator.$refs.viewport.updateParticipant(this.peerList[i]);
                    }
                }
            }
        }
    }
    sendRoomStatus(public_key) {
        if (this.role != "host")
            return;
        // Send room status to the connected peer
        console.log("Sending to peer with", public_key);
        if (vm.$refs.orchestrator) {
            vm.$refs.orchestrator.sendSlides(public_key);
        }
    }
    addTask(task) {
        return (0, status_indicator_1.addTask)(task);
    }
    setupUI() {
        (0, ui_2.setupUI)(this, true);
        (0, ui_1.setupUI)(CommandsManager_1.default, this);
    }
    handleEndOfSession() {
        (0, ui_2.handleEndOfSession)();
    }
    endSession(reason = 'host') {
        console.trace('end the session due to');
        if (this.role == 'host') {
            const confirmString = 'Are you sure you want to end the session? This will disconnect everyone.';
            const r = confirm(confirmString);
            if (r === true) {
                this.sessionEnded = true;
                CommandsManager_1.default.sendAllCommand('end_session');
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
            }
            else {
            }
            return;
        }
        this.sessionEnded = true;
        window.clearInterval(window.timer);
        window.timer = null;
        if (this.sock)
            this.sock.stop();
        this.handleEndOfSession();
        if (reason == 'USER') {
            document.querySelector('#hangup-button').classList.add('hidden');
            document.querySelector('#hangup-button').classList.add('hidden');
            document.querySelector('#endOfSession .host-disconnect-message').classList.add('hidden');
            document.querySelector('#endOfSession .user-disconnect-message').classList.remove('hidden');
        }
    }
}
function getParticipantList() {
    // @ts-ignore
    if (vm.$refs.orchestrator)
        return vm.$refs.orchestrator.$refs.participantList;
    // @ts-ignore
    if (vm.$refs.participantList)
        return vm.$refs.participantList;
    return {};
}
exports.default = PresenterManager;
